module.exports = __webpack_public_path__ + "img/0283edb78314e05d63551d330b344de8.svg";